import React from "react";
//import ReactDOM from 'react-dom';
import axios from 'axios'
import { Link } from 'react-router-dom';
//import Menucategory  from '../Components/Menucategory';
import Megamenu  from '../Components/Megamenu';
//import Singlemenu  from '../Components/Singlemenu';
//import Browsecategories  from '../Components/Browsecategories';
class Menubar extends React.Component {
    constructor(){
        super();
        this.state = {
            men : [],title : []
        }
    }
    componentDidMount(){
    axios.get(encodeURI(process.env.REACT_APP_API_URL +'api/method/ecom.api.main_groups'), {
        headers : { 'content-type': 'application/json'}
       
    })
    .then(response=>{
        this.setState({men:response.data['message']})
        
    })
    .catch(err=>{console.log(err)})
    
     
    
    
    
    
    
    }
 
     render() {
         return <div>
<div className="header-menu bg-white sticky-nav d-lg-block d-none padding-0px">
            <div className="container">
                <div className="row">
                  
                    <div className="col-lg-12">
                            <div className="header-horizontal-menu">
                                <ul className="menu-content">
                                    
                                {this.state.men.map((itm,k)=>{
                                    return(
                                    
                                        <li key={k} className="menu-dropdown">
                                            <a href={'/'+itm.route} img={itm.image} className="mainnav__link">{itm.name}  </a>
                                         <Megamenu groups={itm.route} img={itm.image}/>
                                     </li>
                                    )
                                })} 
                                        <li className=""> <a href={"/about-us"} className="mainnav__link">About Us</a></li>
                                        <li className=""> <a href={"/contact-us"} className="mainnav__link">Contact Us</a></li>
                                    
                                </ul>
                            </div>
                        </div>
                </div>
               {/*  <!-- row --> */}
            </div>
           {/*  <!-- container --> */}
        </div>
    </div>
 }
}
export default Menubar;